// APP-6/MIL-STD-2525 symbolgenerering for kartet, via milsymbol.
// Ett ikon per unik SIDC caches og registreres som MapLibre-bilde (map.addImage)
// slik at symbol-laget kan referere det med icon-image = sidc. Skalerer til
// mange enheter fordi bilde-atlaset gjenbrukes (jf. ATAK-web-spec §3).
import ms from 'milsymbol';
import type { Map as MlMap } from 'maplibre-gl';

const registered = new Set<string>();

/** Registrerer et APP-6-symbol for [sidc] i kartet hvis det ikke finnes. */
export function ensureSymbol(map: MlMap, sidc: string, size = 44): void {
  if (registered.has(sidc) || map.hasImage(sidc)) {
    registered.add(sidc);
    return;
  }
  const sym = new ms.Symbol(sidc, { size, standard: 'APP6', outlineWidth: 2 });
  const canvas = sym.asCanvas() as HTMLCanvasElement;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const { width, height } = canvas;
  const data = ctx.getImageData(0, 0, width, height);
  map.addImage(sidc, { width, height, data: data.data }, { pixelRatio: 2 });
  registered.add(sidc);
}
